<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button type="primary" @click="addAssetDeptBtnClick()" size="mini">新增资产所属部门</el-button>
      </div>
      <!-- <el-col class="item-input" :span="12">
        <label>搜索：</label>
        <el-input v-model="filterKey" size="mini" placeholder="你可以搜索所属部门名称/所属部门编码"></el-input>
      </el-col> -->
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" align="center" width="100">
      </el-table-column>
      <el-table-column prop="name" label="资产所属部门" align="left">
      </el-table-column>
      <el-table-column label="操作" width="200" align="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑该所属部门" placement="bottom">
            <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="editAssetDeptBtnClick(scope.row)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除该所属部门" placement="bottom">
            <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="deleteAssetDept(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 添加所属部门 -->
    <div class="pop-room" v-if="addAssetDeptStatus">
      <a href="javascript:;" @click="addAssetDeptStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form" @submit.native.prevent>
            <el-form-item label="所属部门名字">
              <el-input size="small" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="submitAssetDept()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        addAssetDeptStatus: false,

        form: {
          // 默认指定depid是集团，为以后可能分来各水司做保留
          depId: '',
          name: ""
        },
        formType: 0,

        // 列表
        loading: true,
        pageSize: 50,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        filterKey: "",
      }
    },
    mounted() {
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
      this.getLists()
    },
    components: {},
    methods: {
      // 编辑所属部门按钮点击
      editAssetDeptBtnClick(row) {
        this.addAssetDeptStatus = true
        this.form.assetDeptId = row.id
        this.form.name = row.name
        this.formType = 1
      },
      // 新增所属部门按钮点击
      addAssetDeptBtnClick() {
        this.addAssetDeptStatus = true
        this.form.name = ""
        this.formType = 0
      },
      // 所属部门form提交
      submitAssetDept() {
        let _url = this.formType == 0 ? '/asset/dept/add' : '/asset/dept/edit'
        ajax.post(_url, this.form, (res) => {
          this.addAssetDeptStatus = false
          this.$message.success("提交成功")
          this.getLists()
        })
      },
      // 删除所属部门
      deleteAssetDept(row) {
        this.$confirm('此操作将永久删除该所属部门, 所属部门请勿随意删除，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/asset/dept/del', {
            assetDeptId: row.id
          }, (res) => {
            this.$message.success("删除所属部门成功")
            this.getLists()
          })
        }).catch(() => {});
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterKey) != -1 || _new.num.indexOf(this.filterKey) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/asset/dept/list', {
          depId: this.form.depId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      filterKey() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/assetDept.vue